import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Auth relies on httpOnly cookies set by the backend (no token in localStorage).
export const api = axios.create({ baseURL: API, withCredentials: true });
export const fileUrl = (id) => `${API}/files/${id}`;

export const intlLocale = () => (localStorage.getItem("cpi_locale") === "en" ? "en-GB" : "it-IT");
export const eur = (n) => new Intl.NumberFormat(intlLocale(), { style: "currency", currency: "EUR" }).format(Number(n) || 0);
export const fmtDate = (iso, withTime = false) => {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleDateString(intlLocale(), { day: "2-digit", month: "short", year: "numeric", ...(withTime ? { hour: "2-digit", minute: "2-digit" } : {}) });
};

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Qualcosa è andato storto";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d?.msg || String(d);
};

export const uploadFile = async (file) => {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/files", fd);
  return data;
};

export const STATUS = {
  nuova: { cls: "bg-amber-100 text-amber-800 border-amber-200" },
  sopralluogo_da_pagare: { cls: "bg-amber-100 text-amber-800 border-amber-200" },
  sopralluogo_pagato: { cls: "bg-indigo-100 text-indigo-800 border-indigo-200" },
  sopralluogo_programmato: { cls: "bg-indigo-100 text-indigo-800 border-indigo-200" },
  preventivo_inviato: { cls: "bg-blue-100 text-blue-800 border-blue-200" },
  preventivo_accettato: { cls: "bg-orange-100 text-orange-800 border-orange-200" },
  confermato: { cls: "bg-emerald-100 text-emerald-800 border-emerald-200" },
  in_corso: { cls: "bg-emerald-100 text-emerald-800 border-emerald-200" },
  saldo_da_pagare: { cls: "bg-orange-100 text-orange-800 border-orange-200" },
  chiuso: { cls: "bg-green-100 text-green-800 border-green-200" },
  rifiutato: { cls: "bg-stone-200 text-stone-700 border-stone-300" },
  annullato: { cls: "bg-stone-200 text-stone-700 border-stone-300" },
};

export const ROLE_HOME = { admin: "/admin", worker: "/operaio", partner: "/operaio", customer: "/app" };

export const stepIndex = (req) => {
  const s = req.status;
  const insp = req.path === "inspection";
  const map = insp
    ? { sopralluogo_da_pagare: 1, sopralluogo_pagato: 2, sopralluogo_programmato: 2, preventivo_inviato: 3, preventivo_accettato: 5, confermato: 6, in_corso: 6, saldo_da_pagare: 7, chiuso: 8 }
    : { nuova: 1, preventivo_inviato: 1, preventivo_accettato: 3, confermato: 4, in_corso: 4, saldo_da_pagare: 5, chiuso: 6 };
  return map[s] ?? 0;
};
